import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, Image, H3, H5, Paragraph, colors } from '@fs/zion-ui'
import YouthTempleBlessingPNG from '../../assets/img/promised-blessings-video.png'
import BitmovinPlayer from '../../video/eden-bitmovin-player/src/index'
import { brightcoveConfig } from '../../video/configs'
import { cdnRoot } from '../../services/services'

export default function PrepareForSpirituallyTemple() {
  const [t] = useTranslation()

  const pageStyles = css`
    [data-text-color-alert] {
      color: ${colors.red60};
    }
  `

  return (
    <main>
      <LayoutBand maxWidth="xs" css={pageStyles}>
        <Separator />
        <Image
          alt={t('temple.picture.alt.blessings', 'Promised blessings of the temple')}
          src={`${cdnRoot}/connect/informational/promised_blessings_temple.png`}
        />
        <Separator />
        <H3>{t('informational.temple.prepare.blessings.heading', 'Temple and Family History Blessings')}</H3>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.blessings.intro',
            'One way to help prepare your child for temple baptisms is to talk about the blessings that come from this type of service. This can also help build the anticipation and excitement for that first, special visit to the temple.'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.blessings.subheader', 'Blessings for the Dead—and for the Living')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.blessings.paragraph1',
            'When we remember the feelings we had at our own baptism and confirmation, it is easier to imagine the joy felt by those who receive these ordinances by proxy. Imagining their joy is a sweet experience. At the same time, have you ever wondered if there are blessings available to those here on earth who come to know, cherish, and serve their ancestors in the temple?'
          )}
        </Paragraph>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.blessings.paragraph2',
            'Prophets and apostles have promised amazing blessings to those who participate in temple and family history work. They include:'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.blessings.one', 'Power to change...')}</H5>
        <H5>{t('informational.temple.prepare.blessings.two', 'Power to learn...')}</H5>
        <H5>{t('informational.temple.prepare.blessings.three', 'Increased faith in the Savior...')}</H5>
        <H5>{t('informational.temple.prepare.blessings.four', 'Protection against the adversary...')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.blessings.paragraph3',
            'There are many others. Watch “The Promised Blessings of Family History” video below to hear more:'
          )}
        </Paragraph>
        <Separator />
        <BitmovinPlayer
          thumbnail={YouthTempleBlessingPNG}
          videoData={{ videoId: '4457842874001', accountId: brightcoveConfig.master.accountId }}
        />
        <Separator />
        <H5 data-text-color-alert>
          {t(
            'informational.temple.prepare.blessings.activity-prompt',
            'ACTIVITY: As a family, take a few moments to talk about the blessings mentioned in the video.'
          )}
        </H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare2.step4-details',
            'The temple is the Lord’s house. He wants us to be ready in every way when we go so that we can feel the peace and blessings that come from serving in the temple. Part of getting ready involves visiting with the bishop or branch president. He asks us questions that help us focus on Jesus Christ and how we can be worthy through His Atonement.'
          )}
        </Paragraph>
        <Separator />
      </LayoutBand>
    </main>
  )
}
